(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2025-holiday-variety-lander-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Mobile image carousel (Embla)
    const carouselRoot = document.querySelector('.image-carousel-wrapper');
    if (!carouselRoot) return;

    const viewport = carouselRoot.querySelector('.lp_image_carousel_embla__viewport');
    if (viewport && typeof EmblaCarousel === 'function') {
      EmblaCarousel(viewport, {
        dragFree: true,
        loop: true
      });
    }

    // --- Interactive Large Image Rotator Only ---
    const lgImg   = document.querySelector('.img-wrapper-lg img');
    const nextBtn = document.querySelector('.img-lg-container .lp-main-next-btn');
    const prevBtn = document.querySelector('.img-lg-container .lp-main-prev-btn');
    const thumbs  = Array.from(document.querySelectorAll('.img-wrapper-sm img'));

    if (lgImg) {
      // Build a unified slides array: first the main image, then all thumbs
      const slides = [
        {
          src: lgImg.getAttribute('src'),
          alt: lgImg.getAttribute('alt') || ''
        },
        ...thumbs.map(img => ({
          src: img.getAttribute('src'),
          alt: img.getAttribute('alt') || ''
        }))
      ];

      let currentIndex = 0; // start on the main image

      const updateLgImage = () => {
        const slide = slides[currentIndex];
        lgImg.src = slide.src;
        lgImg.alt = slide.alt;
      };

      const rotateForward = () => {
        currentIndex = (currentIndex + 1) % slides.length;
        updateLgImage();
      };

      const rotateBackward = () => {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        updateLgImage();
      };

      // Main image click
      lgImg.addEventListener('click', rotateForward);

      // Arrows (click only as before)
      if (nextBtn) nextBtn.addEventListener('click', rotateForward);
      if (prevBtn) prevBtn.addEventListener('click', rotateBackward);

      // Thumbs: add tabindex + click + keydown
      thumbs.forEach((thumb, index) => {
        thumb.style.cursor = 'pointer';
        thumb.setAttribute('tabindex', '0');

        const activateThumb = () => {
          // +1 because slides[0] is the original large image
          currentIndex = index + 1;
          updateLgImage();
        };

        thumb.addEventListener('click', activateThumb);

        thumb.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activateThumb();
          }
        });
      });

      // --- Mobile swipe on main image (max-width: 529px) ---
      if (window.matchMedia('(max-width: 529px)').matches) {
        let touchStartX = 0;
        const minSwipeDistance = 40; // px, tweak if needed

        lgImg.addEventListener(
          'touchstart',
          (e) => {
            touchStartX = e.touches[0].clientX;
          },
          { passive: true }
        );

        lgImg.addEventListener(
          'touchend',
          (e) => {
            const touchEndX = e.changedTouches[0].clientX;
            const distance = touchEndX - touchStartX;

            // Ignore tiny swipes / taps
            if (Math.abs(distance) < minSwipeDistance) return;

            if (distance > 0) {
              // swipe left → right = next image
              rotateBackward();
            } else {
              // swipe right → left = previous image
              rotateForward();
            }
          },
          { passive: true }
        );
      }
    }

    // FAQ toggle: add tabindex + click + keydown
    document.querySelectorAll('.faq-question').forEach((question) => {
      question.setAttribute('tabindex', '0');

      const toggleFAQ = () => {
        question.classList.toggle('open');
      };

      question.addEventListener('click', toggleFAQ);

      question.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleFAQ();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-landing-page_heading-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
      // Mobile image carousel
      const carouselRoot = document.querySelector('.image-carousel-wrapper');
      if (!carouselRoot) return;

      const viewport = carouselRoot.querySelector('.lp_image_carousel_embla__viewport');
      EmblaCarousel(viewport, {
        dragFree: true,
        loop: true
      });

    // --- Interactive Large Image Rotator Only ---
      const lgImg = document.querySelector('.img-wrapper-lg img');
      const nextBtn = document.querySelector('.img-lg-container .lp-main-next-btn');
      const prevBtn = document.querySelector('.img-lg-container .lp-main-prev-btn');

      if (lgImg) {
        // Gather all images (large + small) with both src and alt
        const allImages = [
          { src: lgImg.src, alt: lgImg.alt },
          ...Array.from(document.querySelectorAll('.img-wrapper-sm img')).map(img => ({
            src: img.src,
            alt: img.alt
          }))
        ];

        let currentIndex = 0;

        const updateLgImage = () => {
          lgImg.src = allImages[currentIndex].src;
          lgImg.alt = allImages[currentIndex].alt;
        };

        const rotateForward = () => {
          currentIndex = (currentIndex + 1) % allImages.length;
          updateLgImage();
        };

        const rotateBackward = () => {
          currentIndex = (currentIndex - 1 + allImages.length) % allImages.length;
          updateLgImage();
        };

        lgImg.addEventListener('click', rotateForward);
        if (nextBtn) nextBtn.addEventListener('click', rotateForward);
        if (prevBtn) prevBtn.addEventListener('click', rotateBackward);
      }

      // FAQ toggle
      document.querySelectorAll('.faq-question').forEach((question) => {
        question.addEventListener('click', () => {
          question.classList.toggle('open');
        });
      });

      // Make entire container clickable
      document.querySelectorAll('.buy-option-container, .buy-option-container-lg-product').forEach((container) => {
        container.addEventListener('click', () => {
          const input = container.querySelector('input[type="radio"]');
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change'));
          }
        });
      });

      document.querySelector('.buy-option-container-lg-footer')?.addEventListener('click', () => {
        const radio = document.querySelector('.buy-option-container-lg-product input[type="radio"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change')); // Trigger change event if needed
        }
      
        // Remove "selected" from all .buy-option-container elements
        document.querySelectorAll('.buy-option-container.selected').forEach((el) => {
          el.classList.remove('selected');
        });
      
        // Add "selected" to .buy-option-container-lg
        document.querySelector('.buy-option-container-lg')?.classList.add('selected');
      });


      //Handle selected visual state
      document.querySelectorAll('input[type="radio"][name="id"]').forEach((input) => {
        input.addEventListener('change', () => {
          document.querySelectorAll('.buy-option-container, .buy-option-container-lg-product').forEach((el) => {
            el.classList.remove('selected');
          });
          const container = input.closest('.buy-option-container') || input.closest('.buy-option-container-lg-product');
          if (container) {
            container.classList.add('selected');
          }
        });
      });

      // for borders
    document.querySelectorAll('.buy-option-container, .buy-option-container-lg-product').forEach((container) => {
  container.addEventListener('click', () => {
    // Remove 'selected' from all containers that actually have borders
    document.querySelectorAll('.buy-option-container, .buy-option-container-lg').forEach((el) => {
      el.classList.remove('selected');
    });

    // Add 'selected' to the correct outer container
    const outer = container.closest('.buy-option-container') || container.closest('.buy-option-container-lg');
    if (outer) {
      outer.classList.add('selected');
    }
  });
});
    

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-landing-page_info"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const carouselRoot = document.querySelector('.landing-page_info_carousel');
    if (!carouselRoot) return;

    const viewport = carouselRoot.querySelector('.info_carousel_embla__viewport');
    EmblaCarousel(viewport, {
      loop: true,
      dragFree: true
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-landing-page_nutrition"] && !Shopify.designMode) return;
  try {
    
 
  document.addEventListener('DOMContentLoaded', () => {
    const emblaRoot = document.querySelector('.nutrition-cards-carousel');
    if (!emblaRoot) return;

    const viewport = emblaRoot.querySelector('.embla__viewport');
    EmblaCarousel(viewport, {
      dragFree: true,
      loop: true
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-landing-page_reviews"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', () => {
  const carousels = [
    {
      rootSelector: '.check-out-each-flavor',
      viewportSelector: '.embla__viewport'
    },
    {
      rootSelector: '.craftmix-lovers',
      viewportSelector: '.embla__viewport'
    }
  ];

  carousels.forEach(({ rootSelector, viewportSelector }) => {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    const viewport = root.querySelector(viewportSelector);
    if (!viewport) return;

    EmblaCarousel(viewport, {
      dragFree: true,
      loop: true
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-main-blog"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.getElementById("load-more-btn");
  const blogGrid = document.querySelector(".blog-main-grid");
  const blogCta = document.querySelector(".main-blog-cta");

  if (!loadMoreBtn) {
    console.error("❌ Load More button not found.");
    return;
  }

  function getNextFocusableAfter(node) {
    if (!node) return null;

    const selector =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    let el = node;

    while (el) {
      // Scan next siblings (and their descendants)
      let sib = el.nextElementSibling;
      while (sib) {
        if (sib.matches && sib.matches(selector)) return sib;

        if (sib.querySelector) {
          const inside = sib.querySelector(selector);
          if (inside) return inside;
        }

        sib = sib.nextElementSibling;
      }

      // Move up and keep scanning
      el = el.parentElement;
    }

    return null;
  }

  function hideCtaAndRefocus(existingCount) {
    loadMoreBtn.style.display = "none";
    if (blogCta) blogCta.style.display = "none";

    // Prefer the next focusable element after the CTA (keeps forward tab flow)
    const next = getNextFocusableAfter(blogCta || loadMoreBtn);

    if (next) {
      requestAnimationFrame(() => {
        try { next.focus(); } catch (e) {}
      });
      return;
    }

    // Fallback: focus first newly appended article (or first focusable inside it)
    if (!blogGrid) return;
    const allArticles = blogGrid.querySelectorAll(".custom-blog-article-card");
    const firstNew = allArticles[existingCount];

    if (firstNew) {
      const target =
        firstNew.querySelector('a[href], button, [tabindex]:not([tabindex="-1"])') || firstNew;

      if (target === firstNew && !firstNew.hasAttribute("tabindex")) {
        // programmatic focus only (does not add tab stop)
        firstNew.setAttribute("tabindex", "-1");
      }

      requestAnimationFrame(() => {
        try { target.focus(); } catch (e) {}
      });
    }
  }

  loadMoreBtn.addEventListener("click", function (event) {
    event.preventDefault();

    let currentPage = parseInt(loadMoreBtn.getAttribute("data-current-page"));
    let totalPages = parseInt(loadMoreBtn.getAttribute("data-total-pages"));
    let blogHandle = loadMoreBtn.getAttribute("data-blog-handle");
    let nextPage = currentPage + 1;

    // Capture current article count so we can identify the first newly appended article
    const existingCount = blogGrid
      ? blogGrid.querySelectorAll(".custom-blog-article-card").length
      : 0;

    if (nextPage > totalPages) {
      hideCtaAndRefocus(existingCount);
      return;
    }

    let fetchUrl = `/blogs/${blogHandle}?page=${nextPage}`;

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((data) => {
        let parser = new DOMParser();
        let newDocument = parser.parseFromString(data, "text/html");
        let newArticles = newDocument.querySelectorAll(".custom-blog-article-card");

        if (newArticles.length === 0) {
          console.warn("⚠️ No new articles found.");
          // If we expected more but got none, treat it as end-of-results
          hideCtaAndRefocus(existingCount);
          return;
        }

        newArticles.forEach((article) => {
          blogGrid.appendChild(article);
        });

        // Update the button to the next page
        loadMoreBtn.setAttribute("data-current-page", nextPage);

        // Hide CTA if it's the last page
        if (nextPage >= totalPages) {
          hideCtaAndRefocus(existingCount);
        }
      })
      .catch((error) => console.error("❌ Error loading more articles:", error));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-variety-lander-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
      // Mobile image carousel
      const carouselRoot = document.querySelector('.image-carousel-wrapper');
      if (!carouselRoot) return;

      const viewport = carouselRoot.querySelector('.lp_image_carousel_embla__viewport');
      EmblaCarousel(viewport, {
        dragFree: true,
        loop: true
      });

    // --- Interactive Large Image Rotator Only ---
      const lgImg = document.querySelector('.img-wrapper-lg img');
      const nextBtn = document.querySelector('.img-lg-container .lp-main-next-btn');
      const prevBtn = document.querySelector('.img-lg-container .lp-main-prev-btn');

      if (lgImg) {
        // Get all image sources from the DOM
        allSources = [
          lgImg.src,
          ...Array.from(document.querySelectorAll('.img-wrapper-sm img')).map(img => img.src)
        ];

        let currentIndex = 0;

        const updateLgImage = () => {
          lgImg.src = allSources[currentIndex];
        };

        const rotateForward = () => {
          currentIndex = (currentIndex + 1) % allSources.length;
          updateLgImage();
        };

        const rotateBackward = () => {
          currentIndex = (currentIndex - 1 + allSources.length) % allSources.length;
          updateLgImage();
        };

        lgImg.addEventListener('click', rotateForward);
        if (nextBtn) nextBtn.addEventListener('click', rotateForward);
        if (prevBtn) prevBtn.addEventListener('click', rotateBackward);
      }

      // FAQ toggle
      document.querySelectorAll('.faq-question').forEach((question) => {
        question.addEventListener('click', () => {
          question.classList.toggle('open');
        });
      });

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-variety-lander-nutrition"] && !Shopify.designMode) return;
  try {
    
 
  document.addEventListener('DOMContentLoaded', () => {
    const emblaRoot = document.querySelector('.nutrition-cards-carousel');
    if (!emblaRoot) return;

    const viewport = emblaRoot.querySelector('.embla__viewport');
    EmblaCarousel(viewport, {
      dragFree: true,
      loop: true
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["2025-variety-lander-reviews"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', () => {
  const carousels = [
    {
      rootSelector: '.check-out-each-flavor',
      viewportSelector: '.embla__viewport'
    },
    {
      rootSelector: '.craftmix-lovers',
      viewportSelector: '.embla__viewport'
    }
  ];

  carousels.forEach(({ rootSelector, viewportSelector }) => {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    const viewport = root.querySelector(viewportSelector);
    if (!viewport) return;

    EmblaCarousel(viewport, {
      dragFree: true,
      loop: true
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Custom-flavor-carousel"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.product-card-add-btn');
  const variantSelects = document.querySelectorAll('select[name="product-variant-size"]');

  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const productId = this.getAttribute('data-product-id');
      const variantSelect = document.getElementById(`product-variant-size-${productId}`);
      const variantId = variantSelect.value;
      const quantity = 1;

      addToCart(variantId, quantity);
    });
  });

  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const productId = this.id.split('-').pop();
      const selectedVariant = this.options[this.selectedIndex];
      const variantPrice = selectedVariant.getAttribute('data-price');
      const priceElement = this.closest('.product-card').querySelector('.variant-price');
      
      if (priceElement && variantPrice) {
        priceElement.textContent = formatMoney(variantPrice);
      }
    });
  });

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
     
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
      
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-about-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const faqs = document.querySelectorAll('.faq');
  
  faqs.forEach(faq => {
    faq.addEventListener('click', () => {
      // Close all other FAQs
      faqs.forEach(item => {
        if (item !== faq && item.classList.contains('active')) {
            item.classList.remove('active');
        }
      });
      
      // Toggle the clicked FAQ
      faq.classList.toggle('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-about-info"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("about-video");
  const playIcon = document.getElementById("play-toggle");
  const volumeIcon = document.getElementById("volume-icon");
  const muteIcon = document.getElementById("mute-icon");
  const videoWrapper = document.getElementById("video-wrapper");
  const volumeToggle = document.getElementById("volume-toggle");

  // Helper: toggle play/pause state
  function togglePlayPause() {
    if (video.paused) {
      video.play();
      playIcon.style.display = "none";
      playIcon.tabIndex=-1
    } else {
      video.pause();
      playIcon.style.display = "inline";
      playIcon.tabIndex=0
    }
  }

  // Handle video click: anywhere except volume button
  videoWrapper.addEventListener("click", function (e) {
    if (!volumeToggle.contains(e.target)) {
      togglePlayPause();
    }
  });

  // Keyboard: Enter / Space

  videoWrapper.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      // Prevent spacebar scrolling
      e.preventDefault();

      // Do not toggle if focus is on volume button
      if (!volumeToggle.contains(document.activeElement)) {
        togglePlayPause();
      }
    }
  });

  // Move focus to video wrapper when play button disappears

  playIcon.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      requestAnimationFrame(() => {
        videoWrapper.focus();
      });
    }
  });

  // Handle volume toggle
  volumeToggle.addEventListener("click", function () {
    video.muted = !video.muted;
    volumeIcon.style.display = video.muted ? "none" : "inline";
    muteIcon.style.display = video.muted ? "inline" : "none";
  });

  volumeToggle.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();

      video.muted = !video.muted;
      volumeIcon.style.display = video.muted ? "none" : "inline";
      muteIcon.style.display = video.muted ? "inline" : "none";
    }
  });

  // Pause when out of view
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          if(!video.paused && !video.ended){
            togglePlayPause();
          }
        }
      });
    },
    { threshold: 0.2 }
  );

  observer.observe(video);
});
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-cocktail-info"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const carouselRoot = document.querySelector('.landing-page_info_carousel');
    if (!carouselRoot) return;

    const viewport = carouselRoot.querySelector('.info_carousel_embla__viewport');
    EmblaCarousel(viewport, {
      loop: true,
      dragFree: true
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-cocktail-main"]) return;
  try {
    
(() => {
 const instances = new WeakMap();
 function init(root) { root.querySelectorAll('[data-cocktail-gallery]').forEach(section => {
  if (instances.has(section)) return;
  const controller = new AbortController();
  const instance = {controller, embla: null, retry: null};
  instances.set(section, instance);
  const checkoutForm = section.querySelector('[data-cocktail-checkout]');
  const checkoutButton = checkoutForm?.querySelector('.buy-button');
  if (checkoutForm && checkoutButton) {
   const submitCheckout = event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutButton.disabled) return;

    checkoutButton.disabled = true;
    checkoutForm.setAttribute('aria-busy', 'true');
    // Native submission bypasses cart-drawer hooks and honors return_to.
    HTMLFormElement.prototype.submit.call(checkoutForm);
   };
   checkoutForm.addEventListener('click', event => {
    if (event.target.closest('.buy-button')) submitCheckout(event);
   }, {capture: true, signal: controller.signal});
   checkoutForm.addEventListener('submit', submitCheckout, {capture: true, signal: controller.signal});
   window.addEventListener('pageshow', () => {
    checkoutButton.disabled = false;
    checkoutForm.removeAttribute('aria-busy');
   }, {signal: controller.signal});
  }
  const image = section.querySelector('.img-wrapper-lg img');
  if (image) {
   const images = [image,...section.querySelectorAll('.img-wrapper-sm img')].map(img=>({src:img.src,alt:img.alt}));
   let index=0;
   const rotate = step => { index=(index+step+images.length)%images.length; image.src=images[index].src; image.alt=images[index].alt; };
   image.addEventListener('click',()=>rotate(1),{signal:controller.signal});
   section.querySelector('.lp-main-next-btn')?.addEventListener('click',()=>rotate(1),{signal:controller.signal});
   section.querySelector('.lp-main-prev-btn')?.addEventListener('click',()=>rotate(-1),{signal:controller.signal});
  }
  const viewport = section.querySelector('.lp_image_carousel_embla__viewport');
  let attempts = 0;
  const initMobile = () => {
   if (controller.signal.aborted || instance.embla || !viewport) return;
   if (typeof window.EmblaCarousel === 'function') {
    instance.embla = window.EmblaCarousel(viewport, {dragFree:true,loop:true});
   } else if (attempts++ < 20) {
    instance.retry = setTimeout(initMobile, 250);
   }
  };
  initMobile();
 }); }
 if(document.readyState !== 'complete') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true}); else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-cocktail-gallery]').forEach(section=>{const instance=instances.get(section);if(instance){instance.controller.abort();clearTimeout(instance.retry);instance.embla?.destroy();instances.delete(section);}}));
})();

  document.addEventListener('DOMContentLoaded', () => {
      // FAQ toggle
      document.querySelectorAll('.faq-question').forEach((question) => {
        question.addEventListener('click', () => {
          question.classList.toggle('open');
        });
      });

      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-cocktail-nutrition"] && !Shopify.designMode) return;
  try {
    
 
  document.addEventListener('DOMContentLoaded', () => {
    const emblaRoot = document.querySelector('.nutrition-cards-carousel');
    if (!emblaRoot) return;

    const viewport = emblaRoot.querySelector('.embla__viewport');
    EmblaCarousel(viewport, {
      dragFree: true,
      loop: true
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-cocktail-reviews"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', () => {
  const carousels = [
    {
      rootSelector: '.craftmix-lovers',
      viewportSelector: '.embla__viewport'
    }
  ];

  carousels.forEach(({ rootSelector, viewportSelector }) => {
    const root = document.querySelector(rootSelector);
    if (!root) return;

    const viewport = root.querySelector(viewportSelector);
    if (!viewport) return;

    EmblaCarousel(viewport, {
      dragFree: true,
      loop: true
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq-filters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".custom-faq-filter");
  let keyboardActivation = false;

  // Mark the *next* activation as keyboard-driven
  document.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") keyboardActivation = true;
  }, true);

  // Pointer users should not trigger focus moves
  document.addEventListener("mousedown", function () {
    keyboardActivation = false;
  }, true);
  document.addEventListener("touchstart", function () {
    keyboardActivation = false;
  }, true);

  function focusFirstFaqInSection(sectionEl) {
    if (!sectionEl) return;

    // Your consolidated FAQ script makes these focusable (tabindex="0")
    const firstFaq = sectionEl.querySelector(
      ".product-faq, .ingredient-faq, .shipping-faq, .account-faq"
    );

    if (firstFaq) {
      // Wait a frame so scrollIntoView/layout settles
      requestAnimationFrame(() => {
        firstFaq.focus();
      });
    }
  }

  buttons.forEach((button) => {
    // Ensure Space activates like Enter across browsers
    button.addEventListener("keydown", function (e) {
      if (e.key === " ") {
        e.preventDefault();
        keyboardActivation = true;
        button.click();
      }
    });

    button.addEventListener("click", function () {
      const category = this.getAttribute("data-category");
      const targetSection = document.getElementById(category);

      // Set active button state
      buttons.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");

      // Scroll to the section
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: "smooth" });

        // If activated by keyboard, move focus to the destination
        if (keyboardActivation) {
          focusFirstFaqInSection(targetSection);
        }
      }

      // Reset so mouse clicks after a keydown don't inherit the behavior
      keyboardActivation = false;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const FAQ_GROUP_SELECTORS = [
    '.account-faq',
    '.ingredient-faq',
    '.product-faq',
    '.shipping-faq'
  ];

  const ACTIVATION_KEYS = new Set(['Enter', ' ']);

  function isInteractiveEl(el, root) {
    if (!el) return false;

    // Native interactive elements
    const native = el.closest('a[href], button, input, select, textarea');
    if (native) return true;

    // Role-based buttons, but ignore the FAQ root itself
    const roleBtn = el.closest('[role="button"]');
    return !!(roleBtn && roleBtn !== root);
  }

  FAQ_GROUP_SELECTORS.forEach((selector) => {
    const faqs = Array.from(document.querySelectorAll(selector));
    if (!faqs.length) return;

    faqs.forEach((faq) => {
      if (!faq.hasAttribute('tabindex')) faq.setAttribute('tabindex', '0');
      if (!faq.hasAttribute('role')) faq.setAttribute('role', 'button');
      if (!faq.hasAttribute('aria-expanded')) {
        faq.setAttribute('aria-expanded', faq.classList.contains('active') ? 'true' : 'false');
      }

      const answer = faq.querySelector('.faq-answer');

      if (faq.classList.contains('active') && answer) {
        answer.style.height = answer.scrollHeight + 'px';
        faq.setAttribute('aria-expanded', 'true');
      } else {
        if (answer) answer.style.height = '0px';
        faq.setAttribute('aria-expanded', 'false');
      }

      function closeItem(item) {
        item.classList.remove('active');
        item.setAttribute('aria-expanded', 'false');
        const itemAnswer = item.querySelector('.faq-answer');
        if (itemAnswer) itemAnswer.style.height = '0px';
      }

      function openItem(item) {
        item.classList.add('active');
        item.setAttribute('aria-expanded', 'true');
        const itemAnswer = item.querySelector('.faq-answer');
        if (itemAnswer) itemAnswer.style.height = itemAnswer.scrollHeight + 'px';
      }

      function toggleCurrent() {
        const isActive = faq.classList.contains('active');

        faqs.forEach((item) => {
          if (item !== faq) closeItem(item);
        });

        if (isActive) closeItem(faq);
        else openItem(faq);
      }

      faq.addEventListener('click', (e) => {
        if (isInteractiveEl(e.target, faq)) return;
        toggleCurrent();
      });

      faq.addEventListener('keydown', (e) => {
        if (isInteractiveEl(e.target, faq) && e.target !== faq) return;

        if (ACTIVATION_KEYS.has(e.key)) {
          e.preventDefault();
          toggleCurrent();
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hydration-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
 function init(root) { root.querySelectorAll('[data-hydration-faq]').forEach(section => {
 if (section.dataset.hydrationInitialized) return;
 section.dataset.hydrationInitialized = 'true';
 const faqs = section.querySelectorAll('.faq');
 faqs.forEach(faq => {
  const question = faq.querySelector('.question');
  question.setAttribute('role','button');
  question.setAttribute('aria-expanded',String(faq.classList.contains('faq-active')));
  question.addEventListener('click', () => {
   const open = !faq.classList.contains('faq-active');
   faqs.forEach(item => { const active = item === faq && open; item.classList.toggle('faq-active',active); item.querySelector('.question').setAttribute('aria-expanded',String(active)); });
  });
  question.addEventListener('keydown', event => { if(event.key === 'Enter' || event.key === ' ') { event.preventDefault(); question.click(); } });
 });
 }); }
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true}); else init(document);
 document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hydration-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      root.querySelectorAll('[data-hydration-main]').forEach(section => {
        if (section.dataset.initialized) return;
        section.dataset.initialized = 'true';
        const hero = section.querySelector('[data-hydration-hero]');
        section.querySelectorAll('[data-hydration-image]').forEach(button => {
          button.addEventListener('click', () => {
            if (!hero) return;
            hero.src = button.dataset.hydrationImage;
            hero.alt = button.querySelector('img').alt;
            section.querySelectorAll('[data-hydration-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          });
        });

        const checkoutForm = section.querySelector('[data-hydration-checkout]');
        const checkoutButton = checkoutForm?.querySelector('.hydration-offer-cta');
        if (checkoutForm && checkoutButton) {
          const submitCheckout = event => {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (checkoutButton.disabled) return;

            checkoutButton.disabled = true;
            checkoutForm.setAttribute('aria-busy', 'true');
            // Native submission bypasses cart-drawer hooks and honors return_to.
            HTMLFormElement.prototype.submit.call(checkoutForm);
          };

          checkoutForm.addEventListener('click', event => {
            if (event.target.closest('.hydration-offer-cta')) submitCheckout(event);
          }, { capture: true });
          checkoutForm.addEventListener('submit', submitCheckout, { capture: true });

          window.addEventListener('pageshow', () => {
            checkoutButton.disabled = false;
            checkoutForm.removeAttribute('aria-busy');
          });
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hydration-nutrition"] && !Shopify.designMode) return;
  try {
    
(() => {
 function init(root) { root.querySelectorAll('[data-hydration-nutrition]').forEach(section => {
 if (section.dataset.hydrationInitialized) return;
 section.dataset.hydrationInitialized = 'true';
 const selectors = section.querySelectorAll('.nutrition-card-selector');
 const containers = section.querySelectorAll('.nutrition-facts-container');
 selectors.forEach(button => button.addEventListener('click', () => {
  const slugClass = Array.from(button.classList).find(name => name.endsWith('-nutrition-card-selector'));
  if (!slugClass) return;
  const slug = slugClass.replace('-nutrition-card-selector', '');
  selectors.forEach(item => item.classList.toggle('selected', item.classList.contains(slugClass)));
  containers.forEach(item => item.classList.toggle('active', item.classList.contains(slug + '-nutrition-facts-container')));
 }));
 section.querySelectorAll('.flavor-bar').forEach(bar => {
  const percentage = Math.max(0, Math.min(100, parseInt(bar.dataset.flavor, 10) || 0));
  const fill = bar.querySelector('.flavor-range-fill'), icon = bar.querySelector('.flavor-icon');
  if (fill && icon) { fill.style.width = percentage + '%'; icon.style.left = percentage + '%'; }
 });
 }); }
 if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true}); else init(document);
 document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-faq"] && !Shopify.designMode) return;
  try {
    

// document.addEventListener('DOMContentLoaded', function () {
//   const faqs = document.querySelectorAll('.faq');

//   faqs.forEach(faq => {
//     const question = faq.querySelector('.question');
//     const answer = faq.querySelector('.answer');

//     question.addEventListener('click', () => {
     
//       faqs.forEach(otherFaq => {
//         const otherAnswer = otherFaq.querySelector('.answer');
//         if (otherFaq !== faq) {
//           otherFaq.classList.remove('faq-active');
//           if (otherAnswer) otherAnswer.style.maxHeight = null;
//         }
//       });

      
//       faq.classList.toggle('faq-active');

//       if (faq.classList.contains('faq-active')) {
//         answer.style.maxHeight = answer.scrollHeight + "px";
//       } else {
//         answer.style.maxHeight = null;
//       }
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  const faqs = document.querySelectorAll('.faq');
  const section = document.querySelector('.custom-product-faq-section');
  const faqBody = document.querySelector('.product-faq-body');

  function updateSectionHeight() {
    if (section && faqBody) {
      const faqHeight = faqBody.offsetHeight;
      section.style.height = faqHeight + 'px';
    }
  }

  faqs.forEach(faq => {
    const question = faq.querySelector('.question');
    const answer = faq.querySelector('.answer');

    question.addEventListener('click', () => {
      // Close all other open FAQs first
      faqs.forEach(otherFaq => {
        const otherAnswer = otherFaq.querySelector('.answer');
        if (otherFaq !== faq) {
          otherFaq.classList.remove('faq-active');
          if (otherAnswer) otherAnswer.style.maxHeight = null;
        }
      });

      // Toggle current FAQ
      faq.classList.toggle('faq-active');

      if (faq.classList.contains('faq-active')) {
        answer.style.maxHeight = answer.scrollHeight + "px";
      } else {
        answer.style.maxHeight = null;
      }

      // Delay height update to allow for smooth transition
      setTimeout(updateSectionHeight, 300);
    });
  });

  // Initial height set on load
  updateSectionHeight();
});


 
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-section"] && !Shopify.designMode) return;
  try {
    


//Flavor card product slide
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.change-flavor-body');
  let isDown = false;
  let startX;
  let scrollLeft;
  let isDragging = false;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.style.cursor = 'grabbing';
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.style.cursor = 'grab';
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.style.cursor = 'grab';
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2; // Scroll speed
    slider.scrollLeft = scrollLeft - walk;
    isDragging = true;
  });

// Handle clicks on flavor cards
const flavorCards = document.querySelectorAll('.flavor-card');
flavorCards.forEach((card) => {
  card.addEventListener('click', (e) => {
    if (!isDragging) {
      const productHandle = card.getAttribute('data-product-handle');
      const productTitle = card.querySelector('.flavor-card-heading').textContent;
      
      // Navigate to the product page using the product handle
      if (productHandle) {
        window.location.href = `/products/${productHandle}`;
        console.log('Navigating to product:', productTitle);
      } else {
        console.error('Product handle not found for:', productTitle);
      }
    }
    isDragging = false;
  });
});

  // Reset isDragging on mouse up
  document.addEventListener('mouseup', () => {
    isDragging = false;
  });
});
// Subscriptions Test
document.addEventListener("DOMContentLoaded", function () {
  const oneTimeOption = document.querySelector("#one-time-purchase");
  const subscribeOption = document.querySelector("#skio-subscribe");
  const frequencyButtons = document.querySelectorAll("[data-skio='frequency']");
  const skioSubscriptionData = document.querySelector("#skio-subscription-data");
  const variantInput = document.querySelector("#selected-variant-id");
  const variantButtons = document.querySelectorAll(".quantity");

  function updateSubscriptionData() {
    if (subscribeOption.checked) {
      const selectedFrequency = document.querySelector(".delivery.active")?.dataset.frequency || "4"; // Default 4 weeks
      skioSubscriptionData.value = JSON.stringify({ frequency: selectedFrequency });
    } else {
      skioSubscriptionData.value = "";
    }
  }

  function updateVariantSelection() {
    const activeVariant = document.querySelector(".quantity.active");
    if (activeVariant) {
      variantInput.value = activeVariant.dataset.variantId; // Ensure this is a valid number
    }
  }

  // Handle purchase option change
  subscribeOption.addEventListener("change", updateSubscriptionData);
  oneTimeOption.addEventListener("change", updateSubscriptionData);

  // Handle delivery frequency selection
  frequencyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      document.querySelectorAll(".delivery").forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");
      updateSubscriptionData();
    });
  });

  // Handle variant selection (if applicable)
  variantButtons.forEach((button) => {
    button.addEventListener("click", function () {
      document.querySelectorAll(".quantity").forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");
      updateVariantSelection();
    });
  });

  // Ensure the first variant is always selected on load
  if (variantButtons.length > 0) {
    updateVariantSelection();
  }
  
  // Set initial subscription data
  updateSubscriptionData();
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-review-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.custom-sub-review-carousel-card');
  const videos = document.querySelectorAll('.custom-video-review-carousel-video');

  cards.forEach(card => {
    const video = card.querySelector('.custom-video-review-carousel-video');
    const playBtn = card.querySelector('.play-btn');
    const volumeBtn = card.querySelector('.volume-btn');
    const volumeIcon = volumeBtn.querySelector('.volume-icon');
    const muteIcon = volumeBtn.querySelector('.mute-icon');

    // Fade-in fix: Add 'ready' class once video is actually rendering a frame
    video.addEventListener('playing', () => {
      video.classList.add('ready');
    });

    // Play/Pause Button Click
    playBtn.addEventListener('click', () => {
      if (video.paused) {
        pauseAllVideos(video); // Ensure only one video plays
        video.play();
        playBtn.style.display = 'none';
      } else {
        video.pause();
        playBtn.style.display = 'block';
      }
    });

    // Video Click to Play/Pause
    video.addEventListener('click', () => {
      if (video.paused) {
        pauseAllVideos(video);
        video.play();
        playBtn.style.display = 'none';
      } else {
        video.pause();
        playBtn.style.display = 'block';
      }
    });

    // Reset Play Button when Video Ends
    video.addEventListener('ended', () => {
      playBtn.style.display = 'block';
    });

    // Volume Control Button
    volumeBtn.addEventListener('click', () => {
      if (video.muted) {
        video.muted = false;
        volumeIcon.style.display = 'block';
        muteIcon.style.display = 'none';
      } else {
        video.muted = true;
        volumeIcon.style.display = 'none';
        muteIcon.style.display = 'block';
      }
    });
  });

  // Function to Pause All Other Videos
  function pauseAllVideos(currentVideo) {
    videos.forEach(video => {
      if (video !== currentVideo) {
        video.pause();
      }
    });
  }

  // Pause Videos When They Go Out of View
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        entry.target.pause();
      }
    });
  }, { threshold: 0.1 });

  videos.forEach(video => observer.observe(video));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-review-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const productId = "{{ product.id }}"; 
    const apiKey = "pubkey-h1PPDjY5cY7uYdSLPag1Hy61c4mXa3"; 
    const storeUrl = "craftmix.myshopify.com"; 
    const apiUrl = `https://stamped.io/api/widget/reviews?store=${storeUrl}&productId=${productId}&apiKey=${apiKey}`;

    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        const reviewsContainer = document.getElementById("custom-reviews");
        reviewsContainer.innerHTML = ""; // Clear existing content

        if (data.reviews && data.reviews.length > 0) {
          data.reviews.forEach(review => {
            const verifiedBadge = review.verified ? `
              <div class="verified">
                <img src="https://cdn.shopify.com/s/files/1/2340/1623/files/tick-icon.png?v=1739131445" alt="Verified">
                <p>Verified buyer</p>
              </div>` : '';

            const recommendedBadge = review.recommend ? `
              <div class="recommend">
                <img src="https://cdn.shopify.com/s/files/1/2340/1623/files/tick-icon.png?v=1739131445" alt="Recommended">
                <p>I recommend this product</p>
              </div>` : '';

            const reviewHtml = `
              <div class="product-review">
                <div class="product-review-client-details">
                  <h5 class="client-name">${review.author}</h5>
                  <div class="credentials">
                    ${verifiedBadge}
                    ${recommendedBadge}
                  </div>
                </div>
                <div class="product-review-client-review">
                  <div class="stars">${renderStars(review.rating)}</div>
                  <h5 class="review-title">${review.title}</h5>
                  <p class="review-text">${review.message}</p>
                </div>
              </div>
            `;
            reviewsContainer.innerHTML += reviewHtml;
          });
        } else {
          reviewsContainer.innerHTML = "<p>No reviews yet. Be the first to review this product!</p>";
        }
      })
      .catch(error => {
        console.error("Error fetching reviews:", error);
        document.getElementById("custom-reviews").innerHTML = "<p>Failed to load reviews.</p>";
      });

    // Helper function to render stars dynamically
    function renderStars(rating) {
      let starHtml = '';
      for (let i = 0; i < 5; i++) {
        if (i < rating) {
          starHtml += '<img src="https://cdn.shopify.com/s/files/1/2340/1623/files/star-filled.svg?v=123456789" alt="★">';
        } else {
          starHtml += '<img src="https://cdn.shopify.com/s/files/1/2340/1623/files/star-empty.svg?v=123456789" alt="☆">';
        }
      }
      return starHtml;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-sub-video-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.custom-sub-review-carousel-card');
  const videos = document.querySelectorAll('.custom-video-review-carousel-video');

  cards.forEach(card => {
    const video = card.querySelector('.custom-video-review-carousel-video');
    const playBtn = card.querySelector('.play-btn');
    const volumeBtn = card.querySelector('.volume-btn');
    const volumeIcon = volumeBtn.querySelector('.volume-icon');
    const muteIcon = volumeBtn.querySelector('.mute-icon');

    // Fade-in fix: Add 'ready' class once video is actually rendering a frame
    video.addEventListener('playing', () => {
      video.classList.add('ready');
    });

    // Play/Pause Button Click
    playBtn.addEventListener('click', () => {
      if (video.paused) {
        pauseAllVideos(video); // Ensure only one video plays
        video.play();
        playBtn.style.display = 'none';
      } else {
        video.pause();
        playBtn.style.display = 'block';
      }
    });

    // Video Click to Play/Pause
    video.addEventListener('click', () => {
      if (video.paused) {
        pauseAllVideos(video);
        video.play();
        playBtn.style.display = 'none';
      } else {
        video.pause();
        playBtn.style.display = 'block';
      }
    });

    // Reset Play Button when Video Ends
    video.addEventListener('ended', () => {
      playBtn.style.display = 'block';
    });

    // Volume Control Button
    volumeBtn.addEventListener('click', () => {
      if (video.muted) {
        video.muted = false;
        volumeIcon.style.display = 'block';
        muteIcon.style.display = 'none';
      } else {
        video.muted = true;
        volumeIcon.style.display = 'none';
        muteIcon.style.display = 'block';
      }
    });
  });

  // Function to Pause All Other Videos
  function pauseAllVideos(currentVideo) {
    videos.forEach(video => {
      if (video !== currentVideo) {
        video.pause();
      }
    });
  }

  // Pause Videos When They Go Out of View
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        entry.target.pause();
      }
    });
  }, { threshold: 0.1 });

  videos.forEach(video => observer.observe(video));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-2026-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPrankHeroCarousels = (scope = document) => {
      const carousels = scope.querySelectorAll
        ? scope.querySelectorAll('[data-prank-hero-carousel]')
        : [];

      carousels.forEach((carousel) => {
        if (carousel.dataset.carouselInitialized === 'true') return;

        const track = carousel.querySelector('[data-prank-hero-track]');
        const slides = Array.from(carousel.querySelectorAll('.espresso-hero__slide'));
        const viewport = carousel.querySelector('.espresso-hero__viewport');
        const prevButton = carousel.querySelector('[data-prank-hero-prev]');
        const nextButton = carousel.querySelector('[data-prank-hero-next]');

        if (!track || !viewport || !prevButton || !nextButton || slides.length < 2) return;

        let currentIndex = 0;
        let startX = 0;
        let currentX = 0;
        let isTouching = false;

        const goToSlide = (index) => {
          if (index < 0) {
            currentIndex = slides.length - 1;
          } else if (index >= slides.length) {
            currentIndex = 0;
          } else {
            currentIndex = index;
          }

          track.style.transform = `translate3d(-${currentIndex * 100}%, 0, 0)`;
          slides.forEach((slide, slideIndex) => {
            slide.setAttribute('aria-hidden', slideIndex == currentIndex ? 'false' : 'true');
          });
        };

        prevButton.addEventListener('click', () => goToSlide(currentIndex - 1));
        nextButton.addEventListener('click', () => goToSlide(currentIndex + 1));

        const onTouchStart = (event) => {
          if (!event.touches || !event.touches.length) return;
          startX = event.touches[0].clientX;
          currentX = startX;
          isTouching = true;
        };

        const onTouchMove = (event) => {
          if (!isTouching || !event.touches || !event.touches.length) return;
          currentX = event.touches[0].clientX;
        };

        const onTouchEnd = () => {
          if (!isTouching) return;

          const deltaX = currentX - startX;
          const swipeThreshold = 40;

          if (deltaX > swipeThreshold) {
            goToSlide(currentIndex - 1);
          } else if (deltaX < -swipeThreshold) {
            goToSlide(currentIndex + 1);
          }

          isTouching = false;
          startX = 0;
          currentX = 0;
        };

        viewport.addEventListener('touchstart', onTouchStart, { passive: true });
        viewport.addEventListener('touchmove', onTouchMove, { passive: true });
        viewport.addEventListener('touchend', onTouchEnd);
        viewport.addEventListener('touchcancel', onTouchEnd);

        carousel.goToPrankHeroSlide = (index) => {
          goToSlide(index);
        };

        goToSlide(0);
        carousel.dataset.carouselInitialized = 'true';
      });
    };

    document.addEventListener('DOMContentLoaded', () => initPrankHeroCarousels(document));
    document.addEventListener('shopify:section:load', (event) => initPrankHeroCarousels(event.target));
    document.addEventListener('shopify:section:reorder', () => initPrankHeroCarousels(document));
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-slide-block-id]');
      const carousel = event.target.closest('[data-prank-hero-carousel]');

      if (!slide || !carousel || typeof carousel.goToPrankHeroSlide !== 'function') return;

      const slides = Array.from(carousel.querySelectorAll('[data-slide-block-id]'));
      const index = slides.indexOf(slide);

      if (index >= 0) {
        carousel.goToPrankHeroSlide(index);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydration-nutrition-facts"] && !Shopify.designMode) return;
  try {
    
// // Flavor Bar
document.addEventListener('DOMContentLoaded', function () {
  const flavorBars = document.querySelectorAll('.flavor-bar');

  flavorBars.forEach(flavorBar => {
    let sweetnessPercentage = parseInt(flavorBar.dataset.flavor, 10) || 0;

    // Clamp to 0–100
    sweetnessPercentage = Math.max(0, Math.min(100, sweetnessPercentage));

    setFlavorRange(flavorBar, sweetnessPercentage);
  });
});

function setFlavorRange(flavorBar, percentage) {
  const fillElement = flavorBar.querySelector('.flavor-range-fill');
  const iconElement = flavorBar.querySelector('.flavor-icon');
  
  if (fillElement && iconElement) {
    fillElement.style.width = `${percentage}%`;
    iconElement.style.left = `${percentage}%`;
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('[data-tab-target]');
  const tabsContent = document.querySelectorAll('[data-tab-content]');

  function activateTab(tab) {
    const target = document.querySelector(tab.dataset.tabTarget);
    if (!target) return;

    tabsContent.forEach(tabContent => {
      tabContent.classList.remove('active');
    });

    tabs.forEach(t => {
      t.classList.remove('active');
    });

    tab.classList.add('active');
    target.classList.add('active');
  }

  tabs.forEach(tab => {
    // Mouse activation
    tab.addEventListener('click', function () {
      activateTab(tab);
    });

    // Keyboard activation
    tab.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // prevent page scroll on Space
        activateTab(tab);
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-2025"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  document.body.classList.add('page-loaded');

  const addToCartButtons = document.querySelectorAll('.product-card-add-btn');
  // console.log(`Found ${addToCartButtons.length} Add to Cart buttons`);

  document.body.addEventListener('click', function(event) {
    const button = event.target.closest('.product-card-add-btn');
    if (button) {
      event.preventDefault();

     let variantId = button.getAttribute('data-product-id');

      if (variantId) {
        addToCart(variantId, 1);
      }
    }
  });

  document.body.addEventListener('change', function(event) {
    if (event.target.matches('select[name="product-variant-size"]')) {
      const select = event.target;
      const productCard = select.closest('.product-card');
      const selectedOption = select.options[select.selectedIndex];
      const variantPrice = selectedOption.getAttribute('data-price');
      const variantid = selectedOption.getAttribute('data-id');
      const priceElement = productCard.querySelector('.variant-price');

      if (priceElement) {
        priceElement.textContent = formatMoney(variantPrice);
        priceElement.setAttribute('data-product-id', variantid);
      }
    }
  });

  // Custom Variant Dropdown Handler
  document.querySelectorAll('.custom-variant-trigger').forEach(trigger => {
    const dropdownId = trigger.getAttribute('data-dropdown-id');
    const dropdown = document.getElementById(dropdownId);
    const selectedText = trigger.querySelector('.selected-variant');

    if (!dropdown || !selectedText) return;

    function focusSelectedOrFirstOption() {
      const options = Array.from(dropdown.querySelectorAll('.variant-option'));
      if (!options.length) return;

      // Make options programmatically focusable (safe even if repeated)
      options.forEach(opt => {
        if (!opt.hasAttribute('tabindex')) opt.setAttribute('tabindex', '-1');
      });

      const selectedLabel = (selectedText.textContent || '').trim();
      const targetOption =
        options.find(o => (o.textContent || '').trim() === selectedLabel) || options[0];

      requestAnimationFrame(() => {
        try { targetOption.focus({ preventScroll: true }); } catch (e) {}
      });
    }

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        trigger.click();
      }
    });

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();

      // Close all other dropdowns
      document.querySelectorAll('.variant-options-container').forEach(d => {
        if (d !== dropdown) d.style.display = 'none';
      });

      // Toggle visibility
      const isOpening = dropdown.style.display !== 'block';

      if (!isOpening) {
        dropdown.style.display = 'none';
        dropdown.classList.remove('below');
      } else {
        dropdown.classList.remove('above');
        dropdown.classList.add('below');
        dropdown.style.display = 'block';

        focusSelectedOrFirstOption();
      }
    });

    dropdown.querySelectorAll('.variant-option').forEach(option => {
      option.addEventListener('keydown', (e) => {
        // Enter/Space selects option AND moves focus to ATC
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();

          option.click();

          const container = option.closest('.variant-options-container');
          const trig = container
            ? document.querySelector(`.custom-variant-trigger[data-dropdown-id="${container.id}"]`)
            : null;

          const cardRoot = trig ? trig.closest('.product-card') : null;
          const addBtn = cardRoot ? cardRoot.querySelector('.product-card-add-btn') : null;

          requestAnimationFrame(() => {
            if (addBtn) addBtn.focus({ preventScroll: true });
          });

          return;
        }

        // Escape exits back to trigger
        if (e.key === 'Escape') {
          e.preventDefault();
          e.stopPropagation();

          const container = option.closest('.variant-options-container');
          if (container) container.style.display = 'none';

          const trig = document.querySelector(
            `.custom-variant-trigger[data-dropdown-id="${container ? container.id : ''}"]`
          );
          if (trig) trig.focus({ preventScroll: true });
          return;
        }

        // Tab routing: Tab goes to ATC, Shift+Tab goes back to trigger
        if (e.key === 'Tab') {
          e.preventDefault();
          e.stopPropagation();

          const container = option.closest('.variant-options-container');
          if (container) container.style.display = 'none';

          const trig = container
            ? document.querySelector(`.custom-variant-trigger[data-dropdown-id="${container.id}"]`)
            : null;

          const cardRoot = trig ? trig.closest('.product-card') : null;
          const addBtn = cardRoot ? cardRoot.querySelector('.product-card-add-btn') : null;

          if (e.shiftKey) {
            requestAnimationFrame(() => {
              if (trig) trig.focus({ preventScroll: true });
            });
          } else {
            requestAnimationFrame(() => {
              if (addBtn) addBtn.focus({ preventScroll: true });
            });
          }
          return;
        }

        // Up/Down arrow navigation between options
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          e.stopPropagation();

          const container = option.closest('.variant-options-container');
          if (!container) return;

          const options = Array.from(container.querySelectorAll('.variant-option'));
          const currentIndex = options.indexOf(option);
          if (currentIndex === -1) return;

          const nextIndex =
            e.key === 'ArrowDown'
              ? Math.min(options.length - 1, currentIndex + 1)
              : Math.max(0, currentIndex - 1);

          const nextOption = options[nextIndex];
          if (nextOption) nextOption.focus({ preventScroll: true });
        }
      });

      option.addEventListener('click', () => {
        const variantId = option.dataset.id;
        const variantPrice = option.dataset.price;
        const title = option.textContent;

        selectedText.textContent = title;
        dropdown.style.display = 'none';

        const productCard = trigger.closest('.product-card');
        const addBtn = productCard ? productCard.querySelector('.product-card-add-btn') : null;
        const priceEl = productCard ? productCard.querySelector('.variant-price') : null;

        if (addBtn) addBtn.setAttribute('data-product-id', variantId);
        if (priceEl) {
          priceEl.textContent = formatMoney(variantPrice);
          priceEl.setAttribute('data-product-id', variantId);
        }

        // After selection via click, land on ATC (same method as carousel)
        requestAnimationFrame(() => {
          if (addBtn) addBtn.focus({ preventScroll: true });
        });
      });
    });
  });


  // Close dropdowns when clicking outside
  document.addEventListener('click', () => {
    document.querySelectorAll('.variant-options-container').forEach(dropdown => {
      dropdown.style.display = 'none';
    });
  });

  // Init filters
  initProductFilter();

  function initProductFilter() {
    const filterLinks = document.querySelectorAll('.filter-link');
    const productCards = document.querySelectorAll('.product-card-container');
    const pinkLeaf = document.querySelector('.mint_pink-bg');
    const blueberry = document.querySelector('.blueberry-bg');

    filterLinks.forEach(link => {
      link.addEventListener('click', function(event) {
  
        const selectedTag = this.getAttribute('data-tag');

        // Update active state
        filterLinks.forEach(l => {
          l.classList.remove('active');
          l.removeAttribute('aria-pressed');
        });
        this.classList.add('active');
        this.setAttribute('aria-pressed', 'true');
        
        // Show/hide cards
        productCards.forEach(card => {
          const cardTags = card.getAttribute('data-tags').split(',');
          const show = selectedTag === 'all' || cardTags.includes(selectedTag);
          card.style.display = show ? 'block' : 'none';

          // Reset SVG (if needed)
          if (show) {
            const svg = card.querySelector('svg');
            if (svg) {
              const clone = svg.cloneNode(true);
              svg.replaceWith(clone);
            }
          }
        });

        pinkLeaf.style.display = selectedTag === 'all' ? 'block' : 'none';
        blueberry.style.display = selectedTag === 'all' ? 'block' : 'none';
      });
    });
  }

  function addToCart(variantId, quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status && data.status !== 200) {
        alert(`Error: ${data.message || 'Could not add to cart'}`);
      } else {
        console.log('Product added to cart:', data);
      }
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `$${dollars}`;
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-nutrition-facts-new"] && !Shopify.designMode) return;
  try {
    
// // Flavor Bar
document.addEventListener('DOMContentLoaded', function () {
  const flavorBars = document.querySelectorAll('.flavor-bar');

  flavorBars.forEach(flavorBar => {
    let sweetnessPercentage = parseInt(flavorBar.dataset.flavor, 10) || 0;

    // Clamp to 0–100
    sweetnessPercentage = Math.max(0, Math.min(100, sweetnessPercentage));

    setFlavorRange(flavorBar, sweetnessPercentage);
  });
});

function setFlavorRange(flavorBar, percentage) {
  const fillElement = flavorBar.querySelector('.flavor-range-fill');
  const iconElement = flavorBar.querySelector('.flavor-icon');
  
  if (fillElement && iconElement) {
    fillElement.style.width = `${percentage}%`;
    iconElement.style.left = `${percentage}%`;
  }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-nutrition-section"] && !Shopify.designMode) return;
  try {
    
// // Flavor Bar
document.addEventListener('DOMContentLoaded', function () {
  const flavorBars = document.querySelectorAll('.flavor-bar');

  flavorBars.forEach(flavorBar => {
    let sweetnessPercentage = parseInt(flavorBar.dataset.flavor, 10) || 0;

    // Clamp to 0–100
    sweetnessPercentage = Math.max(0, Math.min(100, sweetnessPercentage));

    setFlavorRange(flavorBar, sweetnessPercentage);
  });
});

function setFlavorRange(flavorBar, percentage) {
  const fillElement = flavorBar.querySelector('.flavor-range-fill');
  const iconElement = flavorBar.querySelector('.flavor-icon');
  
  if (fillElement && iconElement) {
    fillElement.style.width = `${percentage}%`;
    iconElement.style.left = `${percentage}%`;
  }
}

// // Nutrition Card 
// Hide all expandable rows 
document.querySelectorAll('.nutrition-fact-card').forEach(card => {
  card.querySelectorAll('.expandable').forEach(row => {
    row.style.display = 'none';
  });
});

// Add click listener to each expand button
document.querySelectorAll('.expand-btn').forEach(button => {
  button.addEventListener('click', function () {
    const card = button.closest('.nutrition-fact-card');
    const expandableRows = card.querySelectorAll('.expandable');
    const isOpen = expandableRows[0].style.display === 'table-row';

    expandableRows.forEach(row => {
      row.style.display = isOpen ? 'none' : 'table-row';
    });

    button.textContent = isOpen ? 'See All Nutrition Facts' : 'Collapse Nutrition Facts';
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.custom-review-carousel-card');

  // Pause all other videos when one plays
  function pauseAllOtherVideos(currentVideo) {
    const videos = document.querySelectorAll('.custom-video-review-carousel-video');

    videos.forEach((video) => {
      if (video !== currentVideo) {
        video.pause();
        const parentCard = video.closest('.custom-review-carousel-card');
        const playBtn = parentCard ? parentCard.querySelector('.play-btn') : null;
        if (playBtn) playBtn.style.display = 'block';
      }
    });
  }

  // Pause videos when they leave the viewport
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (!entry.isIntersecting) {
          video.pause();
          const parentCard = video.closest('.custom-review-carousel-card');
          const playBtn = parentCard ? parentCard.querySelector('.play-btn') : null;
          if (playBtn) playBtn.style.display = 'block';
        }
      });
    },
    { threshold: 0.1 }
  );

  // Apply behavior to each video card
  cards.forEach((card) => {
    const video = card.querySelector('.custom-video-review-carousel-video');
    const playBtn = card.querySelector('.play-btn');
    const volumeBtn = card.querySelector('.volume-btn');
    const volumeIcon = volumeBtn ? volumeBtn.querySelector('.volume-icon') : null;
    const muteIcon = volumeBtn ? volumeBtn.querySelector('.mute-icon') : null;

    if (!video || !playBtn || !volumeBtn || !volumeIcon || !muteIcon) return;

    // Persisted user preference: default to whatever the video starts as
    card.dataset.userMuted = video.muted ? 'true' : 'false';

    function syncVolumeIcons() {
      if (video.muted) {
        volumeIcon.style.display = 'none';
        muteIcon.style.display = 'block';
      } else {
        volumeIcon.style.display = 'block';
        muteIcon.style.display = 'none';
      }
    }

    // Ensure icons match initial state
    syncVolumeIcons();

    function toggleVideoPlay() {
      const isPlaying = !video.paused;

      if (isPlaying) {
        video.pause();
        playBtn.style.display = 'block';
        return;
      }

      pauseAllOtherVideos(video);

      // Respect user preference when starting playback
      const prefMuted = card.dataset.userMuted === 'true';
      video.muted = prefMuted;

      video
        .play()
        .then(() => {
          playBtn.style.display = 'none';
        })
        .catch((err) => {
          // If unmuted play is blocked, fall back to muted and persist preference
          video.muted = true;
          card.dataset.userMuted = 'true';
          syncVolumeIcons();

          try {
            const p2 = video.play();
            if (p2 && typeof p2.catch === 'function') p2.catch(() => {});
          } catch (e) {}

          console.error('Video play failed:', err);
        });
    }

    // video.addEventListener('click', (e) => {
    //   e.stopPropagation();
    //   toggleVideoPlay();
    // });

    // playBtn.addEventListener('click', (e) => {
    //   e.stopPropagation();
    //   toggleVideoPlay();
    // });

    video.addEventListener('ended', () => {
      video.pause();
      video.currentTime = 0;
      video.load(); // This resets and shows the poster
      playBtn.style.display = 'block';
    });

    volumeBtn.addEventListener('click', (e) => {
      e.stopPropagation();

      // Toggle mute and persist preference, even if paused
      video.muted = !video.muted;
      card.dataset.userMuted = video.muted ? 'true' : 'false';

      syncVolumeIcons();
    });

    // Start observing the video for scroll visibility
    observer.observe(video);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prank-lander-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPrankHeroCarousels = (scope = document) => {
      const carousels = scope.querySelectorAll
        ? scope.querySelectorAll('[data-prank-hero-carousel]')
        : [];

      carousels.forEach((carousel) => {
        if (carousel.dataset.carouselInitialized === 'true') return;

        const track = carousel.querySelector('[data-prank-hero-track]');
        const slides = Array.from(carousel.querySelectorAll('.espresso-hero__slide'));
        const viewport = carousel.querySelector('.espresso-hero__viewport');
        const prevButton = carousel.querySelector('[data-prank-hero-prev]');
        const nextButton = carousel.querySelector('[data-prank-hero-next]');

        if (!track || !viewport || !prevButton || !nextButton || slides.length < 2) return;

        let currentIndex = 0;
        let startX = 0;
        let currentX = 0;
        let isTouching = false;

        const goToSlide = (index) => {
          if (index < 0) {
            currentIndex = slides.length - 1;
          } else if (index >= slides.length) {
            currentIndex = 0;
          } else {
            currentIndex = index;
          }

          track.style.transform = `translate3d(-${currentIndex * 100}%, 0, 0)`;
          slides.forEach((slide, slideIndex) => {
            slide.setAttribute('aria-hidden', slideIndex == currentIndex ? 'false' : 'true');
          });
        };

        prevButton.addEventListener('click', () => goToSlide(currentIndex - 1));
        nextButton.addEventListener('click', () => goToSlide(currentIndex + 1));

        const onTouchStart = (event) => {
          if (!event.touches || !event.touches.length) return;
          startX = event.touches[0].clientX;
          currentX = startX;
          isTouching = true;
        };

        const onTouchMove = (event) => {
          if (!isTouching || !event.touches || !event.touches.length) return;
          currentX = event.touches[0].clientX;
        };

        const onTouchEnd = () => {
          if (!isTouching) return;

          const deltaX = currentX - startX;
          const swipeThreshold = 40;

          if (deltaX > swipeThreshold) {
            goToSlide(currentIndex - 1);
          } else if (deltaX < -swipeThreshold) {
            goToSlide(currentIndex + 1);
          }

          isTouching = false;
          startX = 0;
          currentX = 0;
        };

        viewport.addEventListener('touchstart', onTouchStart, { passive: true });
        viewport.addEventListener('touchmove', onTouchMove, { passive: true });
        viewport.addEventListener('touchend', onTouchEnd);
        viewport.addEventListener('touchcancel', onTouchEnd);

        carousel.goToPrankHeroSlide = (index) => {
          goToSlide(index);
        };

        goToSlide(0);
        carousel.dataset.carouselInitialized = 'true';
      });
    };

    document.addEventListener('DOMContentLoaded', () => initPrankHeroCarousels(document));
    document.addEventListener('shopify:section:load', (event) => initPrankHeroCarousels(event.target));
    document.addEventListener('shopify:section:reorder', () => initPrankHeroCarousels(document));
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-slide-block-id]');
      const carousel = event.target.closest('[data-prank-hero-carousel]');

      if (!slide || !carousel || typeof carousel.goToPrankHeroSlide !== 'function') return;

      const slides = Array.from(carousel.querySelectorAll('[data-slide-block-id]'));
      const index = slides.indexOf(slide);

      if (index >= 0) {
        carousel.goToPrankHeroSlide(index);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const faqs = document.querySelectorAll('.faq');

  faqs.forEach(faq => {
    const question = faq.querySelector('.question');
    const answer = faq.querySelector('.answer');
    if (!question || !answer) return;

    // Ensure focusability only
    if (!question.hasAttribute('tabindex')) {
      question.setAttribute('tabindex', '0');
    }

    // Initial state
    const isActive = faq.classList.contains('active');
    question.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    answer.style.maxHeight = isActive ? answer.scrollHeight + 'px' : null;

    function toggleFaq() {
      const expanded = faq.classList.toggle('active');
      question.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      answer.style.maxHeight = expanded ? answer.scrollHeight + 'px' : null;
    }

    // Mouse
    question.addEventListener('click', toggleFaq);

    // Keyboard
    question.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // stop Space from scrolling
        toggleFaq();
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-pdp-faq-section"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  const faqs = document.querySelectorAll('.faq');

  faqs.forEach(faq => {
    const question = faq.querySelector('.question');
    const answer = faq.querySelector('.answer');

    question.addEventListener('click', () => {
      faqs.forEach(otherFaq => {
        const otherAnswer = otherFaq.querySelector('.answer');
        if (otherFaq !== faq) {
          otherFaq.classList.remove('faq-active');
          if (otherAnswer) otherAnswer.style.maxHeight = null;
        }
      });

      const isActive = faq.classList.toggle('faq-active');

      if (isActive) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      } else {
        answer.style.maxHeight = null;
      }
    });
  });

  // Initialize open height for the default open one (faq-active)
  const activeAnswer = document.querySelector('.faq-active .answer');
  if (activeAnswer) {
    activeAnswer.style.maxHeight = activeAnswer.scrollHeight + 'px';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-our-fans-say-subscription"] && !Shopify.designMode) return;
  try {
    
  
          document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.custom-video-review-carousel-card');
    const videos = document.querySelectorAll('.custom-video-review-carousel-video');

    cards.forEach(card => {
        const video = card.querySelector('.custom-video-review-carousel-video');
        const playBtn = card.querySelector('.play-btn');
        // const playIcon = playBtn.querySelector('.play-icon');
        const volumeBtn = card.querySelector('.volume-btn');
        const volumeIcon = volumeBtn.querySelector('.volume-icon');
        const muteIcon = volumeBtn.querySelector('.mute-icon');

        // Play/Pause Button Click
        playBtn.addEventListener('click', () => {
            if (video.paused) {
                pauseAllVideos(video); // Ensure only one video plays
                video.play();
                // playIcon.style.display = 'none';
                playBtn.style.display = 'none';
            } else {
                video.pause();
                // playIcon.style.display = 'block';
                playBtn.style.display = 'block';
            }
        });

        // Video Click to Play/Pause
        video.addEventListener('click', () => {
            if (video.paused) {
                pauseAllVideos(video);
                video.play();
                // playIcon.style.display = 'none';
                playButton.style.display = 'none';
            } else {
                video.pause();
                playButton.style.display = 'block';
            }
        });

        // Reset Play Button when Video Ends
        video.addEventListener('ended', () => {
            playBtn.style.display = 'block';
            // playIcon.style.display = 'block';
        });

        // Volume Control Button
        volumeBtn.addEventListener('click', () => {
            if (video.muted) {
                video.muted = false;
                volumeIcon.style.display = 'block';
                muteIcon.style.display = 'none';
            } else {
                video.muted = true;
                volumeIcon.style.display = 'none';
                muteIcon.style.display = 'block';
            }
        });
    });

    // Function to Pause All Other Videos
    function pauseAllVideos(currentVideo) {
        videos.forEach(video => {
            if (video !== currentVideo) {
                video.pause();
            }
        });
    }

    // Pause Videos When They Go Out of View
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                entry.target.pause();
            }
        });
    }, { threshold: 0.1 });

    videos.forEach(video => observer.observe(video));
});      


  } catch(e) { console.error(e); }
})();
})();
